import { render } from "./main_screen.vue?vue&type=template&id=739e94d0"
import script from "./main_screen.vue?vue&type=script&lang=js"
export * from "./main_screen.vue?vue&type=script&lang=js"

import exportComponent from "/home/kabull/js/vue/iqtest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__